// extracted by mini-css-extract-plugin
export default {"headline":"_502+58NB4Bue1leN2mD6Qg==","teasers":"Z5SzE+w0cLfRO5Fb7k5+-g==","teaser":"_0dvkLGZZzuMQysl0eYKlJw==","teaserContent":"_2DA7WVFlXOZr0u7qXPCxhg=="};